import React, { Component } from 'react'

class StickyMobileCTA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
        // Show after scrolling past the hero (roughly 100vh)
        var shouldShow = window.scrollY > window.innerHeight * 0.8;
        if (shouldShow !== this.state.visible) {
            this.setState({ visible: shouldShow });
        }
    }

    render() {
        return (
            <div className={"sticky_mobile_cta" + (this.state.visible ? " visible" : "")}>
                <a href="/menu" className="sticky_cta_btn sticky_cta_menu">
                    菜單
                </a>
                <a href="/order" className="sticky_cta_btn sticky_cta_order">
                    立刻訂購
                </a>
                <a href="tel:0286617800" className="sticky_cta_btn sticky_cta_phone">
                    電話
                </a>
            </div>
        );
    }
}

export default StickyMobileCTA;
